const medusaUrl = __MEDUSA_BACKEND_URL__ || "http://localhost:9000"

export { medusaUrl }
